import { render, staticRenderFns } from "./exportDeclareML.vue?vue&type=template&id=acbc0af2&scoped=true"
import script from "./exportDeclareML.vue?vue&type=script&lang=js"
export * from "./exportDeclareML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbc0af2",
  null
  
)

export default component.exports